import { TFunction } from 'i18next';
import { z } from 'zod';

export const getAddressSchema = (t: TFunction) =>
  z.object({
    description: z.string().nonempty(t('common.validation.descriptionRequired')),
    email: z
      .string()
      .nonempty(t('common.validation.emailRequired'))
      .email(t('common.validation.emailFormatInvalid')),
  });
